// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────────────────────
   contentSectionEditPageNavigation.css
   Scoped prefix: scl--cms-content-edit-navigation-
   Covers: Nav-header, Nav-footer
   ───────────────────────────────────────────────────────────────────────────── */

/* ─── Root ──────────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-root {
  width: 100%;
  max-width: 1920px;
  padding: 10px 130px 20px 130px;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

/* ─── Skeleton ──────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-skeleton-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
}

@keyframes scl--cms-content-edit-navigation-shimmer {
  0%   { background-position: 100% 50%; }
  100% { background-position:   0% 50%; }
}

.scl--cms-content-edit-navigation-skeleton {
  border-radius: 4px;
  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);
  background-size: 400% 100%;
  animation: scl--cms-content-edit-navigation-shimmer 1.4s ease infinite;
}
.scl--cms-content-edit-navigation-skeleton--title { height: 40px; width: 280px; }
.scl--cms-content-edit-navigation-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }
.scl--cms-content-edit-navigation-skeleton--field { height: 44px; width: 100%; }

/* ─── Empty state ───────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 8px;
  text-align: center;
}
.scl--cms-content-edit-navigation-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }
.scl--cms-content-edit-navigation-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }

/* ─── Breadcrumb ────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
}
.scl--cms-content-edit-navigation-breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #8A8B8F;
}

/* ─── Page heading ──────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-page-title {
  margin: 0 0 6px;
  font-size: 36px;
  font-weight: 600;
  line-height: 40px;
  color: #323539;
}
.scl--cms-content-edit-navigation-page-desc {
  margin: 0 0 28px;
  font-size: 16px;
  line-height: 24px;
  color: #8A8B8F;
  letter-spacing: -0.01em;
}

/* ─── Meta grid ─────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
  margin-bottom: 32px;
}
.scl--cms-content-edit-navigation-meta-grid > *:nth-child(5) { grid-column: 1; }

/* ─── Section editor wrapper ────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-section-editor {
  overflow: visible;
  position: relative;
}

/* ─── Section heading row ───────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-section-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
}

.scl--cms-content-edit-navigation-section-heading {
  font-size: 16px;
  font-weight: 600;
  color: #323539;
  margin: 0;
}

/* ─── Divider ───────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-divider {
  height: 1px;
  background: #E1E4ED;
  margin-bottom: 20px;
}

/* ─── Label row ─────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 8px;
}
.scl--cms-content-edit-navigation-label    { font-size: 14px; color: #323539; font-weight: 400; }
.scl--cms-content-edit-navigation-required { color: #FF4D4F; }

/* ─── SplitRow ──────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-split-row {
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 60px;
  background: #FDFDFD;
  border: 1px dashed rgba(208, 213, 221, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.scl--cms-content-edit-navigation-split-row--multiline {
  min-height: 110px;
  align-items: flex-start;
}

/* Green left accent bar */
.scl--cms-content-edit-navigation-split-accent {
  width: 4px;
  flex-shrink: 0;
  background: #84A578;
  border-radius: 0 0 2px 2px;
  align-self: stretch;
}

/* Row body */
.scl--cms-content-edit-navigation-split-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px 10px 16px;
  gap: 12px;
  min-height: 60px;
}

.scl--cms-content-edit-navigation-split-row--multiline
.scl--cms-content-edit-navigation-split-body {
  align-items: flex-start;
  padding-top: 14px;
  padding-bottom: 14px;
  min-height: 110px;
}

/* Current value — left */
.scl--cms-content-edit-navigation-split-current {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
  word-break: break-word;
}

/* Input slot — right */
.scl--cms-content-edit-navigation-split-slot {
  flex-shrink: 0;
  width: 240px;
}

/* Textarea slot */
.scl--cms-content-edit-navigation-split-slot--textarea {
  width: 351px;
}
.scl--cms-content-edit-navigation-split-slot--textarea textarea {
  max-height: 110px;
  overflow-y: auto;
  resize: none;
  box-sizing: border-box;
}

/* ─── Card / selector row ───────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
  position: relative;
  z-index: 10;
  margin-top: 20px;
  margin-bottom: 0;
  padding-bottom: 12px;
  gap: 12px;
}

.scl--cms-content-edit-navigation-card-row > .scl--cms-content-edit-navigation-label {
  flex: 1;
  min-width: 0;
}

.scl--cms-content-edit-navigation-card-row-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  overflow: visible;
  position: relative;
  left: -45px;
  z-index: 10;
}

.scl--cms-content-edit-navigation-card-select,
.scl--cms-content-edit-navigation-card-select .scl--cms-components-selectFieldInline-container {
  width: 220px;
  min-width: 0;
  flex-shrink: 0;
}

.scl--cms-content-edit-navigation-card-row-right > *:last-child {
  flex-shrink: 0;
  flex-grow: 0;
}

.scl--cms-content-edit-navigation-card-select .scl--cms-components-selectFieldInline-dropdown,
.scl--cms-content-edit-navigation-card-select [class*="dropdown"],
.scl--cms-content-edit-navigation-card-select [class*="menu"] {
  z-index: 9999;
  position: absolute;
}

/* ─── Upload row (image / icon) ─────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-upload-label {
  font-size: 14px;
  color: #323539;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 8px;
  display: block;
}

.scl--cms-content-edit-navigation-upload-row {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  min-height: 96px;
  box-sizing: border-box;
  background: transparent;
  border-radius: 10px;
  overflow: hidden;
}

.scl--cms-content-edit-navigation-upload-row::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 1px;
  height: 100%;
  background: rgba(229, 229, 231, 0.5);
  pointer-events: none;
}

/* Left — preview panel */
.scl--cms-content-edit-navigation-upload-preview {
  box-sizing: border-box;
  position: relative;
  width: 50%;
  display: flex;
  align-items: center;
  background: transparent;
  flex-shrink: 0;
  border-right: 1px solid #E5E5E780;
  padding-right: 20px;
}

.scl--cms-content-edit-navigation-upload-preview-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  width: 100%;
  height: 75px;
  background: #FFFFFF;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px dashed #D0D5DD;
}

.scl--cms-content-edit-navigation-upload-thumb {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 0.5px solid #D0D5DD;
  background: #F8F8F8;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--cms-content-edit-navigation-upload-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.scl--cms-content-edit-navigation-upload-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}

.scl--cms-content-edit-navigation-upload-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #323539;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scl--cms-content-edit-navigation-upload-size {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 8px;
  line-height: 18px;
  color: #8A8B8F;
}

/* No data state */
.scl--cms-content-edit-navigation-upload-nodata {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 96px;
  gap: 4px;
  color: #8A8B8F;
  font-size: 12px;
}

/* Right — upload zone */
.scl--cms-content-edit-navigation-upload-zone-wrap {
  width: 50%;
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
  padding-left: 20px;
}

/* ─── Upload zone (native) ──────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 96px;
  border: 1px dashed #D0D5DD;
  border-radius: 8px;
  background: #FAFAFA;
  cursor: pointer;
  gap: 4px;
  padding: 12px;
  box-sizing: border-box;
  transition: background 0.15s;
}
.scl--cms-content-edit-navigation-upload-zone:hover { background: #F5F7FA; }

.scl--cms-content-edit-navigation-upload-zone-icon { margin-bottom: 4px; }

.scl--cms-content-edit-navigation-upload-zone-text {
  font-size: 12px;
  color: #8A8B8F;
  text-align: center;
  line-height: 18px;
}

.scl--cms-content-edit-navigation-upload-zone-link {
  color: #2B7CF7;
  cursor: pointer;
  text-decoration: underline;
}

.scl--cms-content-edit-navigation-upload-zone-hint {
  font-size: 11px;
  color: #B0B3BA;
  text-align: center;
}

/* ─── Footer actions ────────────────────────────────────────────────────────── */
.scl--cms-content-edit-navigation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/content/edit-content/navigation-page/css/contentSectionEditPageNavigation.css"],"names":[],"mappings":"AAAA;;;;kFAIkF;;AAElF,kFAAkF;AAClF;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,sEAAsE;AACxE;AACA,oDAAoD,YAAY,EAAE,YAAY,EAAE;AAChF,oDAAoD,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACpG,oDAAoD,YAAY,EAAE,WAAW,EAAE;;AAE/E,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;AACpB;AACA,gDAAgD,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAC9G,gDAAgD,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAEnG,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA,+DAA+D,cAAc,EAAE;;AAE/E,kFAAkF;AAClF;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA,6CAA6C,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAChG,6CAA6C,cAAc,EAAE;;AAE7D,kFAAkF;AAClF;EACE,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;AACA,sDAAsD,mBAAmB,EAAE;;AAE3E,qDAAqD,kBAAkB,EAAE;;AAEzE;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB","sourcesContent":["/* ─────────────────────────────────────────────────────────────────────────────\n   contentSectionEditPageNavigation.css\n   Scoped prefix: scl--cms-content-edit-navigation-\n   Covers: Nav-header, Nav-footer\n   ───────────────────────────────────────────────────────────────────────────── */\n\n/* ─── Root ──────────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-root {\n  width: 100%;\n  max-width: 1920px;\n  padding: 10px 130px 20px 130px;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n}\n\n/* ─── Skeleton ──────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-skeleton-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 24px;\n}\n\n@keyframes scl--cms-content-edit-navigation-shimmer {\n  0%   { background-position: 100% 50%; }\n  100% { background-position:   0% 50%; }\n}\n\n.scl--cms-content-edit-navigation-skeleton {\n  border-radius: 4px;\n  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);\n  background-size: 400% 100%;\n  animation: scl--cms-content-edit-navigation-shimmer 1.4s ease infinite;\n}\n.scl--cms-content-edit-navigation-skeleton--title { height: 40px; width: 280px; }\n.scl--cms-content-edit-navigation-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }\n.scl--cms-content-edit-navigation-skeleton--field { height: 44px; width: 100%; }\n\n/* ─── Empty state ───────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 8px;\n  text-align: center;\n}\n.scl--cms-content-edit-navigation-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }\n.scl--cms-content-edit-navigation-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }\n\n/* ─── Breadcrumb ────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n.scl--cms-content-edit-navigation-breadcrumb-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: #8A8B8F;\n}\n\n/* ─── Page heading ──────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-page-title {\n  margin: 0 0 6px;\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 40px;\n  color: #323539;\n}\n.scl--cms-content-edit-navigation-page-desc {\n  margin: 0 0 28px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #8A8B8F;\n  letter-spacing: -0.01em;\n}\n\n/* ─── Meta grid ─────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-meta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 24px;\n  margin-bottom: 32px;\n}\n.scl--cms-content-edit-navigation-meta-grid > *:nth-child(5) { grid-column: 1; }\n\n/* ─── Section editor wrapper ────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-section-editor {\n  overflow: visible;\n  position: relative;\n}\n\n/* ─── Section heading row ───────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-section-heading-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.scl--cms-content-edit-navigation-section-heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #323539;\n  margin: 0;\n}\n\n/* ─── Divider ───────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-divider {\n  height: 1px;\n  background: #E1E4ED;\n  margin-bottom: 20px;\n}\n\n/* ─── Label row ─────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n.scl--cms-content-edit-navigation-label    { font-size: 14px; color: #323539; font-weight: 400; }\n.scl--cms-content-edit-navigation-required { color: #FF4D4F; }\n\n/* ─── SplitRow ──────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-split-row {\n  box-sizing: border-box;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 60px;\n  background: #FDFDFD;\n  border: 1px dashed rgba(208, 213, 221, 0.3);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.scl--cms-content-edit-navigation-split-row--multiline {\n  min-height: 110px;\n  align-items: flex-start;\n}\n\n/* Green left accent bar */\n.scl--cms-content-edit-navigation-split-accent {\n  width: 4px;\n  flex-shrink: 0;\n  background: #84A578;\n  border-radius: 0 0 2px 2px;\n  align-self: stretch;\n}\n\n/* Row body */\n.scl--cms-content-edit-navigation-split-body {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px 10px 16px;\n  gap: 12px;\n  min-height: 60px;\n}\n\n.scl--cms-content-edit-navigation-split-row--multiline\n.scl--cms-content-edit-navigation-split-body {\n  align-items: flex-start;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  min-height: 110px;\n}\n\n/* Current value — left */\n.scl--cms-content-edit-navigation-split-current {\n  flex: 1;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.8);\n  word-break: break-word;\n}\n\n/* Input slot — right */\n.scl--cms-content-edit-navigation-split-slot {\n  flex-shrink: 0;\n  width: 240px;\n}\n\n/* Textarea slot */\n.scl--cms-content-edit-navigation-split-slot--textarea {\n  width: 351px;\n}\n.scl--cms-content-edit-navigation-split-slot--textarea textarea {\n  max-height: 110px;\n  overflow-y: auto;\n  resize: none;\n  box-sizing: border-box;\n}\n\n/* ─── Card / selector row ───────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-card-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n  margin-top: 20px;\n  margin-bottom: 0;\n  padding-bottom: 12px;\n  gap: 12px;\n}\n\n.scl--cms-content-edit-navigation-card-row > .scl--cms-content-edit-navigation-label {\n  flex: 1;\n  min-width: 0;\n}\n\n.scl--cms-content-edit-navigation-card-row-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  overflow: visible;\n  position: relative;\n  left: -45px;\n  z-index: 10;\n}\n\n.scl--cms-content-edit-navigation-card-select,\n.scl--cms-content-edit-navigation-card-select .scl--cms-components-selectFieldInline-container {\n  width: 220px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.scl--cms-content-edit-navigation-card-row-right > *:last-child {\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.scl--cms-content-edit-navigation-card-select .scl--cms-components-selectFieldInline-dropdown,\n.scl--cms-content-edit-navigation-card-select [class*=\"dropdown\"],\n.scl--cms-content-edit-navigation-card-select [class*=\"menu\"] {\n  z-index: 9999;\n  position: absolute;\n}\n\n/* ─── Upload row (image / icon) ─────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-upload-label {\n  font-size: 14px;\n  color: #323539;\n  font-weight: 400;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.scl--cms-content-edit-navigation-upload-row {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n  width: 100%;\n  min-height: 96px;\n  box-sizing: border-box;\n  background: transparent;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.scl--cms-content-edit-navigation-upload-row::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n  width: 1px;\n  height: 100%;\n  background: rgba(229, 229, 231, 0.5);\n  pointer-events: none;\n}\n\n/* Left — preview panel */\n.scl--cms-content-edit-navigation-upload-preview {\n  box-sizing: border-box;\n  position: relative;\n  width: 50%;\n  display: flex;\n  align-items: center;\n  background: transparent;\n  flex-shrink: 0;\n  border-right: 1px solid #E5E5E780;\n  padding-right: 20px;\n}\n\n.scl--cms-content-edit-navigation-upload-preview-inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  padding: 0 16px;\n  width: 100%;\n  height: 75px;\n  background: #FFFFFF;\n  box-sizing: border-box;\n  border-radius: 8px;\n  border: 1px dashed #D0D5DD;\n}\n\n.scl--cms-content-edit-navigation-upload-thumb {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  border: 0.5px solid #D0D5DD;\n  background: #F8F8F8;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--cms-content-edit-navigation-upload-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.scl--cms-content-edit-navigation-upload-meta {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.scl--cms-content-edit-navigation-upload-name {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #323539;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.scl--cms-content-edit-navigation-upload-size {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 18px;\n  color: #8A8B8F;\n}\n\n/* No data state */\n.scl--cms-content-edit-navigation-upload-nodata {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 96px;\n  gap: 4px;\n  color: #8A8B8F;\n  font-size: 12px;\n}\n\n/* Right — upload zone */\n.scl--cms-content-edit-navigation-upload-zone-wrap {\n  width: 50%;\n  display: flex;\n  align-items: stretch;\n  flex-shrink: 0;\n  padding-left: 20px;\n}\n\n/* ─── Upload zone (native) ──────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-upload-zone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: 96px;\n  border: 1px dashed #D0D5DD;\n  border-radius: 8px;\n  background: #FAFAFA;\n  cursor: pointer;\n  gap: 4px;\n  padding: 12px;\n  box-sizing: border-box;\n  transition: background 0.15s;\n}\n.scl--cms-content-edit-navigation-upload-zone:hover { background: #F5F7FA; }\n\n.scl--cms-content-edit-navigation-upload-zone-icon { margin-bottom: 4px; }\n\n.scl--cms-content-edit-navigation-upload-zone-text {\n  font-size: 12px;\n  color: #8A8B8F;\n  text-align: center;\n  line-height: 18px;\n}\n\n.scl--cms-content-edit-navigation-upload-zone-link {\n  color: #2B7CF7;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.scl--cms-content-edit-navigation-upload-zone-hint {\n  font-size: 11px;\n  color: #B0B3BA;\n  text-align: center;\n}\n\n/* ─── Footer actions ────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-navigation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
